import { Box, Button, Typography } from '@mui/material';

interface Props {
  onNext: () => void;
}

export default function Step1Welcome({ onNext }: Props) {
  return (
    <Box
      sx={{ mt: 4, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 4 }}
    >
      <Box sx={{ flex: 1 }}>
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>
          Let's get your workspace set up!
        </Typography>
        <Typography variant="body1" sx={{ fontSize: '1.2rem' }}>
          Before you can start analyzing and responding to tenders, we need to gather a few details
          about your company, upload some key documents, and show you around the platform.
        </Typography>
      </Box>
      <Button
        variant="contained"
        size="large"
        onClick={onNext}
        sx={{ fontWeight: 'bold', px: 6, py: 1.5, fontSize: '1.1rem', flexShrink: 0 }}
      >
        Start Setup
      </Button>
    </Box>
  );
}
